import React from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import {
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Checkbox,
  Divider,
  Grid,
} from "@material-ui/core";
import { ExpandLess, ExpandMore }  from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Text from "../../Text/Text";
import { RouteService } from "../../../services/route.service";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  box: {
    border: "3px solid red",
    padding: 20,
    maxHeight: "content-height",
  },
  noOrderText: {
    marginTop: 15,
    fontSize: 12,
  },
  spaceTop: {
    marginTop: 10,
  },
  img: {
    width: 60,
  },
  link: {
    cursor: "pointer",
  },
}));

export default function BuyPermitsForm(props) {
  const history = useHistory();
  const classes = useStyles();
  const homeState = useSelector((state) => state.homeState);
  const inCompleteDetails = props.inCompleteDetails;
  const [open, setOpen] = React.useState(false);

  const handleRedirection = () => {
    history.push(RouteService.profilePage(homeState.customerName));
  };

  return (
    <div className={classes.content} tabIndex='0'>
      <Grid style={{ paddingTop: "50px" }} container spacing={3}>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <div className={classes.box}>
            <Text variant={"h6"}>
              Profile Incomplete
            </Text>
            <Divider />
            <Text className={classes.noOrderText}>
              Before you can purchase your first permit you will need to finish
              setting up your driver profile.
            </Text>
            <div>
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                {Object.keys(inCompleteDetails).map((item) => {
                  if (
                    !inCompleteDetails[item].data &&
                    inCompleteDetails[item].required
                  ) {
                    return (
                      <ListItem>
                        <ListItemIcon>
                          <Checkbox onClick={handleRedirection} />
                        </ListItemIcon>
                        <ListItemText primary={item} />
                        {open ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                    );
                  }
                })}
              </List>
            </div>
          </div>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}
